import { repositoriesRoutes } from '../router/RootRouter';
export function resolveUrlForRUM(match) {
    const correspondRoute = repositoriesRoutes.find((route) => route.path === match.path);
    if (correspondRoute) {
        return correspondRoute.path;
    }
    return match.url;
}
